import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { Table, UncontrolledTooltip, Badge } from 'reactstrap'
import moment from 'moment'
import gql from 'graphql-tag'
import PrimaryListingContainer from "../Material/PrimaryListingContainer"
import { Link } from 'react-router-dom'

const AllLiabilityClaimsQuery = gql`
query AllLiabilityClaimsQuery($orderBy: [String],$first: Int!,$cursor: String,$searchTerm: String,$tpaId: ID,$status: String,$inLitigation: Boolean,$incidentBranchIds: [ID],$incidentDate: Date,$dateAddedGte: Date,$dateAddedLte: Date,$isArchived: Boolean, $externalIdIsNull: Boolean) {
    allLiabilityClaims(orderBy: $orderBy,first: $first,after: $cursor,searchTerm: $searchTerm,tpaId: $tpaId,status: $status,inLitigation: $inLitigation,incidentBranchIds: $incidentBranchIds,incidentDate: $incidentDate,dateAddedGte: $dateAddedGte,dateAddedLte: $dateAddedLte,isArchived: $isArchived, externalIdIsNull: $externalIdIsNull) {
        edges {
            node {
                id
                pk
                dateAdded
                filedDate
                acknowledgmentDate
                externalId
                status
                inLitigation
                reservedAmount
                paidAmount
                estimatedAmount
                claimAmount
                isArchived
                tpa {
                    id
                    name
                }
                adjuster {
                    id
                    name
                }
                incident {
                    id
                    title
                    incidentDate
                    branch {
                        id
                        name
                    }
                }
            }
        }
        pageInfo {
            endCursor
            hasNextPage
            length
        }
    }
    liabilityStatusChoices: __type(name: "IncidentsLiabilityClaimStatusChoices") {
        enumValues {
            name
            description
        }
    }
}
`

class LiabilityClaimList extends Component {
    render() {
        return (
            <PrimaryListingContainer
                listLoading={this.props.loading}
                loadMoreEntries={this.props.allLiabilityClaims && this.props.allLiabilityClaims.pageInfo.hasNextPage ? this.props.loadMoreEntries : null}
                totalFetchedRows={this.props.allLiabilityClaims && this.props.allLiabilityClaims.edges.length}
                pageInfo={this.props.allLiabilityClaims && this.props.allLiabilityClaims.pageInfo}
                refetchListQuery={this.props.refetchQuery}
            >
                <Table responsive>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th className='actions-th'>Actions</th>
                            {this.props.columnConfig?.filter(col => col?.preferenceSettings?.isVisible).map((column) => (
                                column.sortable ?
                                    <th key={column.id} onClick={() => this.props.updateOrder(column.id)} style={{ cursor: "pointer" }}>
                                        {this.props.orderBy.some(order => order.includes(column.id)) ? <i className={"fa " + (this.props.orderBy.includes(column.id) ? 'fa-sort-asc' : 'fa-sort-desc')}></i> : <i className='fa fa-sort'></i>}
                                        &nbsp;&nbsp;{column.name}
                                    </th> :
                                    <th key={column.id}>{column.name}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.allLiabilityClaims && this.props.allLiabilityClaims.edges && this.props.allLiabilityClaims.edges.length > 0 ?
                            this.props.allLiabilityClaims.edges.map((claim, i) =>
                                <tr key={claim.node.id}>
                                    <td>{i + 1}</td>
                                    <td className='actions-td'>
                                        {claim.node.incident?.id ?
                                            <Link to={`/incident/${claim.node.incident.id}#claims`} target="_blank">
                                                <i id={`liabilityClaimDetails${i}`} className="fa fa-external-link" aria-hidden="true" />
                                                <UncontrolledTooltip target={`liabilityClaimDetails${i}`} placement="bottom">View Incident Claims</UncontrolledTooltip>
                                            </Link> :
                                            <span className="null-val-color">--</span>
                                        }
                                    </td>
                                    {this.props.columnConfig?.filter(column => column?.preferenceSettings?.isVisible).map(column => <React.Fragment key={column.id}>
                                        {column.id === "date_added" && <td>{claim.node.dateAdded ? moment(claim.node.dateAdded).format("MM/DD/YYYY") : <span className="null-val-color">--</span>}</td>}
                                        {column.id === "claim_number" && <td>{claim.node.externalId || <span className="null-val-color">--</span>}</td>}
                                        {column.id === "status" &&
                                            <td>
                                                {claim.node.status ? (this.props.liabilityStatusChoices?.enumValues.find(item => item.name === claim.node.status)?.description || claim.node.status) : <span className="null-val-color">--</span>}
                                            </td>
                                        }
                                        {column.id === "tpa" && <td>{claim.node.tpa?.name || <span className="null-val-color">--</span>}</td>}
                                        {column.id === "adjuster" && <td>{claim.node.adjuster?.name || <span className="null-val-color">--</span>}</td>}
                                        {column.id === "incident_name" && <td>{claim.node.incident?.title || <span className="null-val-color">--</span>}</td>}
                                        {column.id === "incident_date" && <td>{claim.node.incident?.incidentDate ? moment(claim.node.incident.incidentDate).format("MM/DD/YYYY") : <span className="null-val-color">--</span>}</td>}
                                        {column.id === "filed_date" && <td>{claim.node.filedDate ? moment(claim.node.filedDate).format("MM/DD/YYYY") : <span className="null-val-color">--</span>}</td>}
                                        {column.id === "acknowledgment_date" && <td>{claim.node.acknowledgmentDate ? moment(claim.node.acknowledgmentDate).format("MM/DD/YYYY") : <span className="null-val-color">--</span>}</td>}
                                        {column.id === "incident_branch" &&
                                            <td>
                                                {claim.node.incident?.branch?.name ?
                                                    <span className="bos-badge bos-badge-blue">{claim.node.incident.branch.name}</span>
                                                    : <span className="null-val-color">--</span>}
                                            </td>
                                        }
                                        {column.id === "in_litigation" && <td>{claim.node.inLitigation ? "Yes" : "No"}</td>}
                                        {column.id === "claim_amount" && <td>{"$" + claim.node.claimAmount}</td>}
                                        {column.id === "paid_amount" && <td>{"$" + claim.node.paidAmount}</td>}
                                        {column.id === "reserved_amount" && <td>{"$" + claim.node.reservedAmount}</td>}
                                        {column.id === "estimated_amount" && <td>{"$" + claim.node.estimatedAmount}</td>}
                                    </React.Fragment>
                                    )}
                                </tr>
                            ) : !this.props.loading && <tr>
                                <td colSpan={10}>No liability claims found!</td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </PrimaryListingContainer>)
    }
}

export default graphql(AllLiabilityClaimsQuery, {
    options: ({ orderBy, searchTerm, tpaId, status, inLitigation, incidentBranchIds, incidentDate, dateAddedGte, dateAddedLte, isArchived, externalIdIsNull }) => ({
        variables: { first: 30, orderBy, searchTerm, tpaId, status, inLitigation, incidentBranchIds, incidentDate, dateAddedGte, dateAddedLte, isArchived, externalIdIsNull },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only'
    }),
    props: ({ data: { loading, allLiabilityClaims, fetchMore, variables, liabilityStatusChoices } }) => ({
        loading,
        allLiabilityClaims,
        variables,
        liabilityStatusChoices,
        refetchQuery: () => {
            let currentLength = allLiabilityClaims && allLiabilityClaims.edges ? allLiabilityClaims.edges.length : 30
            return fetchMore({
                query: AllLiabilityClaimsQuery,
                variables: {
                    ...variables,
                    first: currentLength,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const newEdges = fetchMoreResult.allLiabilityClaims.edges
                    const pageInfo = fetchMoreResult.allLiabilityClaims.pageInfo
                    return {
                        allLiabilityClaims: {
                            edges: [...newEdges],
                            pageInfo,
                            __typename: previousResult.allLiabilityClaims.__typename
                        },
                    }
                },
            })
        },
        loadMoreEntries: () => {
            return fetchMore({
                query: AllLiabilityClaimsQuery,
                variables: {
                    cursor: allLiabilityClaims.pageInfo.endCursor,
                    ...variables
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const newEdges = fetchMoreResult.allLiabilityClaims.edges
                    const pageInfo = fetchMoreResult.allLiabilityClaims.pageInfo
                    return {
                        allLiabilityClaims: {
                            edges: [...previousResult.allLiabilityClaims.edges, ...newEdges],
                            pageInfo,
                            __typename: previousResult.allLiabilityClaims.__typename
                        },
                    }
                },
            })
        },
    })
})(LiabilityClaimList)
